import React, { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { variables } from '../utils';

interface MemberAvatarProps {
  size?: number;
}

const MemberAvatar: React.FC<MemberAvatarProps> = ({ size = 30 }) => {
  const { user } = useContext(UserContext);

  return (
    <>
      {user.avatarUrl ? (
        <div
          className="br-100 cover"
          style={{
            background: `${variables.nearWhite} url(${user.avatarUrl}) center center no-repeat`,
            height: size,
            width: size
          }}
        />
      ) : (
        <div
          className="bg-white navy br-100 ba flex items-center justify-center f6"
          style={{ width: size, height: size }}
        >
          {user.displayName[0]}
        </div>
      )}
    </>
  );
};

export default MemberAvatar;
